import React, { useContext, useEffect, useRef, useState } from 'react'
import Entries from './entries'
import { Link } from 'react-router-dom'
import { FilterIcon } from '../../helper/imagepath'
import Exits from './exits'
import PaymentFilter from './paymentFilter'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { getExitsData, getFailedEntries, getInvoiceOffData, getPaidEntries, getPendingEntries } from '../../redux/slices/paymentSlice'
import { getAllRegion } from '../../redux/slices/regionSlice'
import { formatCustomTrim, getDayStartAndEndTimestamps, getTimeStamp } from '../../helper/function'

const Payments = () => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const handleFilterclearRef = useRef(null)

  const [showFilter, setShowFilter] = useState(false)
  const [activeTab, setActiveTab] = useState('entries')
  const [filterData, setFilterData] = useState({})

  // States for Pending entries
  const [pagePending, setPagePending] = useState(1)
  const [pageSizePending, setPageSizePending] = useState(10)

  // States for Paid entries
  const [pagePaid, setPagePaid] = useState(1)
  const [pageSizePaid, setPageSizePaid] = useState(10)

  // States for Failed entries
  const [pageFail, setPageFail] = useState(1)
  const [pageSizeFail, setPageSizeFail] = useState(10)

  // Status for Invoice Off entries

  const [pageInvoiceOff, setPageInvoiceOff] = useState(1)
  const [pageSizeInvoiceOff, setPageSizeInvoiceOff] = useState(10)

  const [pageExits, setPageExits] = useState(1)
  const [pageSizeExits, setPageSizeExits] = useState(10)

  const getHandleFilterclear = (func) => {
    handleFilterclearRef.current = func
  }

  const callHandleFilterclear = () => {
    if (handleFilterclearRef.current) {
      handleFilterclearRef.current()
    }
  }

  const handlePendingPaginationChange = (newPage, newPageSize) => {
    setPagePending(newPage)
    setPageSizePending(newPageSize)
  }

  const handlePaidPaginationChange = (newPage, newPageSize) => {
    setPagePaid(newPage)
    setPageSizePaid(newPageSize)
  }

  const handleFailedPaginationChange = (newPage, newPageSize) => {
    setPageFail(newPage)
    setPageSizeFail(newPageSize)
  }

  const handleExitsPaginationChange = (newPage, newPageSize) => {
    setPageExits(newPage)
    setPageSizeExits(newPageSize)
  }

  const handleInvoiceOffPaginationChange = (newPage, newPageSize) => {
    setPageInvoiceOff(newPage)
    setPageSizeInvoiceOff(newPageSize)
  }

  const tabs = [
    {
      label: 'Entries',
      target: 'entries',
      component: activeTab === 'entries' && (
        <Entries
          pagePending={pagePending}
          pageSizePending={pageSizePending}
          pagePaid={pagePaid}
          pageInvoiceOff={pageInvoiceOff}
          pageSizePaid={pageSizePaid}
          pageFail={pageFail}
          pageSizeFail={pageSizeFail}
          pageSizeInvoiceOff={pageSizeInvoiceOff}
          handleInvoiceOffPaginationChange={handleInvoiceOffPaginationChange}
          handlePendingPaginationChange={handlePendingPaginationChange}
          handlePaidPaginationChange={handlePaidPaginationChange}
          handleFailedPaginationChange={handleFailedPaginationChange}
          filterData={filterData}
        />
      )
    },
    {
      label: 'Exits',
      target: 'exits',
      component: activeTab === 'exits' && (
        <Exits
          pageExits={pageExits}
          pageSizeExits={pageSizeExits}
          handleExitsPaginationChange={handleExitsPaginationChange}
          filterData={filterData}
        />
      )
    }
    // { label: 'Issuers', target: 'issuers', component: activeTab === 'issuers' && <Issuers /> },
    // { label: 'Summary', target: 'summary', component: activeTab === 'summary' && <Summary /> }
  ]

  useEffect(() => {
    dispatch(getAllRegion())
  }, [])

  const { endOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(filterData?.created_end))

  const fetchEntries = async (status, page, pageSize) => {
    const params = {
      host_name: formatCustomTrim(filterData?.hostname),
      cleaner_name: formatCustomTrim(filterData?.cleaner),
      region_id: filterData?.region,
      startTimestamps: filterData?.created_start && getTimeStamp(filterData?.created_start),
      endTimestamps: filterData?.created_end && endOfDayTimestamp,
      sort_column: 'booking_date_time',
      sort_order: 'DESC',
      page,
      limit: pageSize,
      status
    }
    changeLoader(true)
    try {
      if (status === 'pending') await dispatch(getPendingEntries(params)).unwrap()
      if (status === 'paid') await dispatch(getPaidEntries(params)).unwrap()
      if (status === 'failed') await dispatch(getFailedEntries(params)).unwrap()
      if (status === 'invoice-off') await dispatch(getInvoiceOffData(params)).unwrap()
    } catch (error) {
      console.error(`Error fetching ${status} Entries:`, error)
    } finally {
      changeLoader(false)
    }
  }

  // Fetch Pending Entries
  useEffect(() => {
    activeTab === 'entries' && fetchEntries('pending', pagePending, pageSizePending)
  }, [activeTab, filterData, pagePending, pageSizePending])
  // Fetch Paid Entries
  useEffect(() => {
    activeTab === 'entries' && fetchEntries('paid', pagePaid, pageSizePaid)
  }, [activeTab, filterData, pagePaid, pageSizePaid])

  // Fetch Failed Entries
  useEffect(() => {
    activeTab === 'entries' && fetchEntries('failed', pageFail, pageSizeFail)
  }, [activeTab, filterData, pageFail, pageSizeFail])

  useEffect(() => {
    activeTab === 'entries' && fetchEntries('invoice-off', pageInvoiceOff, pageSizeInvoiceOff)
  }, [activeTab, filterData, pageInvoiceOff, pageSizeInvoiceOff])

  const fetchExits = async (page, pageSize) => {
    const params = {
      host_name: formatCustomTrim(filterData?.hostname),
      cleaner_name: formatCustomTrim(filterData?.cleaner),
      region_id: filterData?.region,
      startTimestamps: filterData?.created_start && getTimeStamp(filterData?.created_start),
      endTimestamps: filterData?.created_end && endOfDayTimestamp,
      sort_column: 'booking_date_time',
      sort_order: 'DESC',
      page,
      limit: pageSize
    }
    changeLoader(true)
    try {
      await dispatch(getExitsData(params)).unwrap()
    } catch (error) {
      console.error(`Error fetching ${status} Entries:`, error)
    } finally {
      changeLoader(false)
    }
  }

  useEffect(() => {
    activeTab === 'exits' && fetchExits(pageExits, pageSizeExits)
  }, [activeTab, filterData, pageExits, pageSizeExits])

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="content-page-header">
            <h5>Payments</h5>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                    <span className="me-2">
                      <img src={FilterIcon} alt="filter" />
                    </span>
                    Filter{' '}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="reviews_section">
          <div className="reviews_topbar">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
              {tabs.map((tab, index) => (
                <li className="nav-item review_btn" role="presentation" key={index}>
                  <button
                    className={`nav-link ${activeTab === tab.target ? 'active' : ''}`}
                    id={`pills-${tab.target}-tab`}
                    data-bs-toggle="pill"
                    data-bs-target={`#pills-${tab.target}`}
                    type="button"
                    role="tab"
                    aria-controls={`pills-${tab.target}`}
                    aria-selected={activeTab === tab.target}
                    onClick={() => {
                      setActiveTab(tab.target)
                      callHandleFilterclear()
                    }}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="tab-content" id="pills-tabContent">
          {tabs.map((tab, index) => (
            <div
              className={`tab-pane fade ${activeTab === tab.target ? 'show active' : ''}`}
              id={`pills-${tab.target}`}
              role="tabpanel"
              aria-labelledby={`pills-${tab.target}-tab`}
              key={index}
            >
              {tab.component}
            </div>
          ))}
        </div>
      </div>
      <PaymentFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        setFilterData={setFilterData}
        handlePendingPaginationChange={handlePendingPaginationChange}
        handlePaidPaginationChange={handlePaidPaginationChange}
        handleFailedPaginationChange={handleFailedPaginationChange}
        handleExitsPaginationChange={handleExitsPaginationChange}
        handleInvoiceOffPaginationChange={handleInvoiceOffPaginationChange}
        onFilterClear={getHandleFilterclear}
      />
    </div>
  )
}

export default Payments
